// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1azQo","bigColWidth":"Table_bigColWidth__1KoI8","biggerColWidth":"Table_biggerColWidth___4apw","row":"Table_row__1vmpG","col":"Table_col__3GEav"};